import Popup from "reactjs-popup";
import React from "react";
import 'reactjs-popup/dist/index.css';
import { makeStyles } from '@material-ui/core/styles';

export function getRatePlanNameById(ratePlans, ratePlanId)
{
    var ratePlanName = '';
    for (var i = 0; i < ratePlans.length; i++) {
        if (ratePlanId === ratePlans[i].ratePlanId) {
            ratePlanName = ratePlans[i].ratePlanName;
        }
    }

    return ratePlanName;
}
export const RoomsAndRatePlans = prop => {
    var roomsAndRatePlans = [];
    var indexRoomsAndRatePlans = 0;
    for (const rooms_and_rate_plan of prop.record.rooms_and_rate_plans) {
        const ratePlans = rooms_and_rate_plan.ratePlans;
        for (var index = 0;  index < rooms_and_rate_plan.occupancies.length; index++) {
            const occupancies = rooms_and_rate_plan.occupancies[index];
            const ratePlanId = occupancies.code.split('_')[2];
            const ratePlanName = getRatePlanNameById(ratePlans, ratePlanId);

            roomsAndRatePlans[indexRoomsAndRatePlans] = [];
            if (roomsAndRatePlans[indexRoomsAndRatePlans][rooms_and_rate_plan.roomTypeId] === undefined) {
                roomsAndRatePlans[indexRoomsAndRatePlans][rooms_and_rate_plan.roomTypeId] = [];
            }
            roomsAndRatePlans[indexRoomsAndRatePlans]['roomTypeId'] = rooms_and_rate_plan.roomTypeId;
            roomsAndRatePlans[indexRoomsAndRatePlans]['roomName'] = rooms_and_rate_plan.roomName;
            roomsAndRatePlans[indexRoomsAndRatePlans]['ratePlanId'] = occupancies.ratePlanId;
            roomsAndRatePlans[indexRoomsAndRatePlans]['code'] = occupancies.code;
            roomsAndRatePlans[indexRoomsAndRatePlans]['ratePlanName'] = ratePlanName;
            roomsAndRatePlans[indexRoomsAndRatePlans]['personQuantity'] = occupancies.personQuantity;

            indexRoomsAndRatePlans++;
        }
    }

    return (<Popup trigger={<button> Click here</button>}
                   position="right center"
                   contentStyle={{ width: '550px', padding: '0px', border: 'none', 'textAlign': 'center' }}>

            <style>{`
            .table-container {
                max-height: 280px;      /* Set your required fixed height here */
                overflow-y: auto;       /* Adds vertical scrollbar only when needed */
                border: 1px solid #ccc; /* Border around the scrollable box */
                width: 100%;            /* Responsive structural width */
            }
            .scroll-table {
                width: 100%;
                border-collapse: collapse;
                font-family: sans-serif;
            }
          `}</style>

            <div className="table-container">
            <table className="scroll-table" border="1">
                <tbody>
                <tr>
                    <th>Категорія</th>
                    <th>Назва тарифу</th>
                    <th>Кількість дорослих</th>
                    <th>Зовнішній код</th>
                </tr>
                {
                    roomsAndRatePlans?.map((resource, index) => {
                        return (
                            <tr key={index}>
                                <td>{resource?.roomName}</td>
                                <td>{resource?.ratePlanName}</td>
                                <td>{resource?.personQuantity}</td>
                                <td>{resource?.code}</td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </table>
        </div>
    </Popup>);
}

export const Owner = prop => {

    return (<Popup trigger={<button> Click here</button>}
                   position="left"
                   contentStyle={{ padding: '0px', border: 'none', 'textAlign': 'left' }}>
        <table border={1} style={{backgroundColor: 'white'}}>
            <tbody>
            <tr><td>ID</td><td>{prop.record.owner.id ? prop.record.owner.id : 'no data'}</td></tr>
            <tr><td>firstName</td><td>{prop.record.owner.firstName ? prop.record.owner.firstName : 'no data'}</td></tr>
            <tr><td>lastName</td><td>{prop.record.owner.lastName ? prop.record.owner.lastName : 'no data'}</td></tr>
            <tr><td>phoneNumber</td><td>{prop.record.owner.phoneNumber ? prop.record.owner.phoneNumber : 'no data'}</td></tr>
            <tr><td>email</td><td>{prop.record.owner.email ? prop.record.owner.email : 'no data'}</td></tr>
            <tr><td>isVerified</td><td>{prop.record.owner.isVerified ? 'true': 'false'}</td></tr>
            <tr><td>hotelIds</td><td>{prop.record.owner.hotelIds ? prop.record.owner.hotelIds.join(' , ') : 'no data'}</td></tr>
            </tbody>
        </table>
    </Popup>);
}

export const HotelDeleteFromYavdoma = prop => {
    const handleClick = () => {
        const isConfirmed = window.confirm('Ви впевнені, що хочете видалити готель '+prop.record.title+' з БД Yavdoma.com ?');
        if (isConfirmed) {
            const url = process.env.REACT_APP_YAVDOMA_API_URL+'/ua/hotel/'+prop.record.id+'/delete';
            const fetchData = async () => {
                try {
                    const response = await fetch(url,{
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });
                    const result = await response.json();
                    alert(result.message);
                } catch (error) {
                    console.error("Fetch error:", error);
                }
            };
            fetchData();
        }
    };
    var returnText = '';
    if (prop.record.provider === 'extranet') {
        returnText = (<button onClick={() => handleClick()}>Delete</button>);
    }
    return returnText;
}

export const handleDeleteHotelFromExtranet = async (record) => {
    const isConfirmed = window.confirm(
        `Ви впевнені, що хочете видалити готель ${record.title} з БД Extranet ?`
    );

    if (!isConfirmed) {
        return;
    }

    const url = `${process.env.REACT_APP_EXTRANET_API_URL}/hotels/${record.external_id}`;
    const data = {
        'X-Extranet-Key': process.env.REACT_APP_EXTRANET_KEY,
        'X-Extranet-Secret': process.env.REACT_APP_EXTRANET_SECRET,
    };

    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();
        alert(result.message || 'Not found');
    } catch (e) {
        console.error(e);
    }
};

export const YavdomaHotelURL = prop => {
     return (<a href={process.env.REACT_APP_YAVDOMA_URL+'/uk/ua/hotels/'+prop.record.id} target="_blank" rel="noopener noreferrer">
        <img src="/house-icon.png" alt="Yavdoma hotel URL" style={{width: '30px', height: '30px'}} /> </a>
    );
}

const formatNote = (htmlString) => {
    if (!htmlString) {
        return '';
    }

    const text = htmlString
        .replace(/<[^>]*>/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 71);

    const limits = [28, 28, 15];
    const lines = [];

    let remaining = text;

    for (const limit of limits) {
        if (!remaining.length) {
            break;
        }

        if (remaining.length <= limit) {
            lines.push(remaining);
            break;
        }

        let cut = remaining.lastIndexOf(' ', limit);

        if (cut <= 0) {
            cut = limit;
        }

        lines.push(remaining.slice(0, cut).trim());
        remaining = remaining.slice(cut).trim();
    }

    return lines.join('\n');
};

export const HotelNotesEditButton = ({ record }) => {
    return (
        <a
            href={`/#/hotels/${record.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="hotel-notes-link"
        >
            <span className="hotel-note-text">
                {formatNote(record.note)}
            </span>

            <svg
                className="hotel-note-icon"
                focusable="false"
                viewBox="0 0 24 24"
                aria-hidden="true"
            >
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
            </svg>
        </a>
    );
};

export const useTooltipStyles = makeStyles({
    tooltip: {
        fontSize: '15px',
        maxWidth: 350,
        backgroundColor: '#2c3e50',
        color: '#fff',
        padding: '12px 16px',
        borderRadius: '8px',
        lineHeight: 1.5,
    },
    arrow: {
        color: '#2c3e50',
    },
});
